import { createAsyncAction } from 'typesafe-actions'

import { RequestConfig, RequestOptions } from 'packages/utils/store'

import { standardAvailabilityService } from '../standardAvailability.service'
import {
  StandardAvailabilityActionTypes,
  NormalizedStandardAvailabiltyApiResponse,
  StandardAvailabilityApiFields,
} from '../standardAvailability.types'

export const fetchStandardAvailabilityAction = createAsyncAction(
  StandardAvailabilityActionTypes.FETCH_STANDARD_AVAILABILITY,
  StandardAvailabilityActionTypes.FETCH_STANDARD_AVAILABILITY_SUCCESS,
  StandardAvailabilityActionTypes.FETCH_STANDARD_AVAILABILITY_FAILURE,
)<
  RequestConfig<NormalizedStandardAvailabiltyApiResponse>,
  NormalizedStandardAvailabiltyApiResponse,
  Error
>()

/**
  since it is possible to have more than one "current_availabiliy" stored in the DB, the
  is_current filter on getParams informs the API to give us only the most current availabilities
*/
export const getParams = (userId?: string): RequestOptions => {
  return {
    fields: { standard_availability: StandardAvailabilityApiFields },
    filter: {
      is_current: true,
      user: userId,
    },
  }
}

export const fetchStandardAvailability =
  (userId?: string) => async dispatch => {
    try {
      const params = getParams(userId)
      const request =
        standardAvailabilityService.fetchStandardAvailability.bind(null, params)
      const result = await dispatch(
        fetchStandardAvailabilityAction.request({ request }),
      )
      dispatch(fetchStandardAvailabilityAction.success(result))
      return result.normalized
    } catch (error) {
      dispatch(fetchStandardAvailabilityAction.failure(error))
      throw error
    }
  }
